// extracted by mini-css-extract-plugin
export default {"recos":"j2-z","productCardOverride":"k2-z","rowHasBadge":"l2-z"};